import React from "react"
import { Container, Title, Body, Item, Text } from "./styles/category"
import { Container as MainContainer } from "../../containers"

export default function Category({ children, ...rest }) {
  return (
    <Container {...rest}>
      <MainContainer>{children}</MainContainer>
    </Container>
  )
}

Category.Title = function CategoryTitle({ children, ...rest }) {
  return <Title {...rest}>{children}</Title>
}

Category.Body = function CategoryBody({ children, ...rest }) {
  return <Body {...rest}>{children}</Body>
}

Category.Item = function CategoryItem({ path, text, to, ...rest }) {
  return (
    <Item {...rest} path={path} to={to}>
      <Text>{text}</Text>
    </Item>
  )
}
